// (B120-1; planning 10-27 14:10) the approved Privacy Policy (legal-text.ts)
import { LegalPage } from "./LegalPage.tsx";
import { PRIVACY } from "./legal-text.ts";

export function PrivacyPage() {
  return <LegalPage title="Privacy Policy" path="/privacy" text={PRIVACY}
    description="TubeForge's privacy policy: what we collect, why, who we share it with, how long we keep it, and how you delete it." />;
}
